import { render, staticRenderFns } from "./Partiya.vue?vue&type=template&id=6aa2a666&scoped=true"
import script from "./Partiya.vue?vue&type=script&lang=js"
export * from "./Partiya.vue?vue&type=script&lang=js"
import style0 from "./Partiya.vue?vue&type=style&index=0&id=6aa2a666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2a666",
  null
  
)

export default component.exports